export const validation = {   
  isEmpty: (value: string): boolean => {
    value = value.trim();
    return !value;

  },
  isInRange: (
      value: number | null,
      min: number,
      max: number,
      validateNull: boolean
  ): boolean => {
    let isValid = false;

    if (!validateNull && value === null) isValid = true;

    if (value) {
      if (value >= min && value <= max) {
        isValid = true;
      }
    }

    return isValid;
  },

  isEmail: (email: string): boolean => {
    let isValid = false;
    if (email) {
      let regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (regEx.test(email)) isValid = true;
    } else {
      isValid = true;
    }

    return isValid;
  },
  isPhone: (phone: string): boolean => {
    let isValid = false;
    if (phone) {
      let regEx = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;

      if (regEx.test(phone)) isValid = true;
    } else {
      isValid = true;
    }

    return isValid;
  },
  
  isUKPostcode: (postcode: string): boolean => {
    let isValid = false;
    if (postcode) {
      //console.log('Validating postcode with regex')
      let regEx = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$/;

      if (regEx.test(postcode)) {
        isValid = true;
      }
    } else {
      isValid = true;
    }

   // console.log(`postcode is ${isValid?"valid":"invalid"}`)
    return isValid;
  }
};
